import React, { useEffect, useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { Country } from 'enums/country';

import numeral from 'numeral';
import 'numeral/locales/en-gb';
import 'numeral/locales/en-za';

const DEFAULT_COUNTRY = 'GB';

const buildCountryObject = (countryCode = DEFAULT_COUNTRY, currencyCode) => {
  const country = Country[countryCode];

  return {
    country: countryCode,
    ...country,
    currency: {
      ...country.currency,
      ...(currencyCode ? { code: currencyCode } : {}),
    },
  };
};

const CountryContext = createContext(null);

export const useCountryContext = () => useContext(CountryContext);

const CountryContextProvider = ({ countryCode, currencyCode, children }) => {
  const [currentCountry, setCurrentCountry] = useState(buildCountryObject(DEFAULT_COUNTRY));

  useEffect(() => {
    setCurrentCountry(buildCountryObject(countryCode, currencyCode));
    numeral.locale(Country[countryCode].locale);
  }, [countryCode, currencyCode]);

  return <CountryContext.Provider value={currentCountry}>{children}</CountryContext.Provider>;
};

CountryContextProvider.propTypes = {
  countryCode: PropTypes.string,
  currencyCode: PropTypes.string,
  children: PropTypes.node,
};

export default CountryContextProvider;
